import { Box, Chip, Grid } from '@mui/material';
import { useIntl } from 'react-intl';
import { InfoM } from '../../components/InfoM';

interface AodGipExportConditionsViewProps {
  exportConditions: any; // Type assertion for GIP export conditions
}

export function AodGipExportConditionsView({ exportConditions }: AodGipExportConditionsViewProps) {
  const { formatMessage } = useIntl();

  const formatEfficiency = (efficiency: number) => {
    return `${Math.round(efficiency)}%`;
  };

  // Efficiency is enabled if it's different than false
  const enableEfficiency = exportConditions?.minEfficiency !== false;

  return (
    <Box>
      <Grid container spacing={3}>
        {exportConditions?.minEfficiency !== undefined && (
          <Grid item xs={12}>
            <InfoM
              label={formatMessage({
                id: 'audit.gip.exportConditions.enableEfficiency',
                defaultMessage: 'Verificar eficiencia mínima',
              })}
            >
              <Chip
                label={
                  enableEfficiency
                    ? formatMessage({
                        id: 'common.enabled',
                        defaultMessage: 'Habilitado',
                      })
                    : formatMessage({
                        id: 'common.disabled',
                        defaultMessage: 'Deshabilitado',
                      })
                }
                color={enableEfficiency ? 'success' : 'default'}
                size="small"
              />
            </InfoM>
          </Grid>
        )}

        {enableEfficiency && exportConditions?.minEfficiency !== undefined && (
          <Grid item xs={12}>
            <InfoM
              label={formatMessage({
                id: 'audit.gip.exportConditions.minEfficiency',
                defaultMessage: 'Eficiencia mínima',
              })}
            >
              {formatEfficiency(exportConditions.minEfficiency as number)}
            </InfoM>
          </Grid>
        )}
      </Grid>
    </Box>
  );
}
